var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 1.03342L15.725 7.63341C15.825 7.73341 15.896 7.84175 15.938 7.95841C15.9793 8.07508 16 8.20008 16 8.33341C16 8.46675 15.9793 8.59175 15.938 8.70841C15.896 8.82508 15.825 8.93341 15.725 9.03341L9.125 15.6334C8.94167 15.8167 8.71267 15.9127 8.438 15.9214C8.16267 15.9294 7.925 15.8334 7.725 15.6334C7.525 15.4501 7.42067 15.2211 7.412 14.9464C7.404 14.6711 7.5 14.4334 7.7 14.2334L12.6 9.33341L1.425 9.33341C1.14166 9.33341 0.904 9.23775 0.711999 9.04642C0.520666 8.85442 0.424999 8.61675 0.424999 8.33341C0.424999 8.05008 0.520665 7.81275 0.711999 7.62142C0.904 7.42942 1.14166 7.33342 1.425 7.33342L12.6 7.33341L7.7 2.43342C7.51667 2.25008 7.42067 2.01675 7.412 1.73341C7.404 1.45008 7.5 1.21675 7.7 1.03342C7.88333 0.833416 8.11666 0.733414 8.4 0.733414C8.68333 0.733414 8.925 0.833416 9.125 1.03342Z",
    fill: "#505050"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6eb8fec7740d39df0c250c9be4c7ec4b.svg";
export { ForwardRef as ReactComponent };